module.exports = __webpack_public_path__ + "static/media/logosekolah-clean.521942a2.png";